import RichText from '@resolvers/rich-text'
import { type RichTextType } from '@resolvers/rich-text/types'
import { modalRichText } from '@rich-text/modal-rich-text'
import { ModalUI } from '@ui/modal/modal'
import React, { type FC, type ReactNode } from 'react'

export type ContactModalProps = {
  open: boolean
  onClose: () => void
  title: string
  content?: RichTextType
  staticContent?: ReactNode
  fullScreen?: boolean
}

export const ContactModal: FC<ContactModalProps> = ({
  title,
  content,
  staticContent,
  open,
  onClose,
  fullScreen = false,
}) => (
  <ModalUI
    fullScreen={fullScreen}
    modalTitle={title}
    visible={open}
    onClose={onClose}
  >
    <RichText content={content} options={modalRichText} />
    {staticContent}
  </ModalUI>
)
